export const addUrlTimestamp = (link: string) => `${link}&d=${new Date().getTime()}`